// Re-export from canonical location — src/components/Profiles/shared/widgets/registry/
// Import directly from WidgetRenderer.tsx (not the barrel) to avoid circular dependency:
// barrel → widgetRegistry → widgets → PlaysSection → this shim → barrel
export {
  WidgetRenderer,
  toProfileWidget,
  setWidgetResolver,
  registerResolverInit,
} from './widgets/registry/WidgetRenderer';
